import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import Layout from "@/components/Layout";
import SEO from "@/components/SEO";
import ReactMarkdown from "react-markdown";
import { MD_COMPONENTS } from "@/lib/markdown";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    setErr(false);
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setErr(true));
  }, [slug]);

  if (err) {
    return (
      <Layout>
        <div className="container-narrow py-32 text-center">
          <p className="font-serif text-2xl text-brand-ink">Essay not found.</p>
          <Link to="/field-notes" className="overline text-brand-rust mt-4 inline-block">Back to Field Notes →</Link>
        </div>
      </Layout>
    );
  }
  if (!post) return <Layout><div className="container-narrow py-32 overline text-brand-inkMuted">Loading…</div></Layout>;

  return (
    <Layout>
      <SEO
        title={post.title}
        description={post.excerpt || (post.body ? String(post.body).replace(/[#*_`>\[\]]/g, "").slice(0, 160) : undefined)}
      />
      <article className="container-narrow py-16 md:py-24 max-w-3xl">
        <Link to="/field-notes" className="overline text-brand-inkMuted hover:text-brand-ink" data-testid="back-to-blog">← Back to Field Notes</Link>
        {post.tag && <span className="overline text-brand-rust block mt-8">{post.tag}</span>}
        <h1 className="font-display text-5xl md:text-6xl mt-3 text-brand-ink leading-[1.05]" data-testid="post-title">{post.title}</h1>
        <p className="overline text-brand-inkMuted mt-4">By {post.author} · {new Date(post.published_at).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>

        <div className="mt-10 aspect-[16/9] bg-brand-bg overflow-hidden border border-brand-line">
          <img
            src={post.cover_image}
            alt={post.title}
            className="w-full h-full object-cover"
            style={{ objectPosition: (post.cover_image || "").includes("forged%20in%20fire") ? "right center" : "center" }}
          />
        </div>

        <div className="mt-10 field-note-body" data-testid="post-body">
          <ReactMarkdown components={MD_COMPONENTS}>
            {post.body || ""}
          </ReactMarkdown>
        </div>
      </article>
    </Layout>
  );
}
